<template>
    <b-card no-body class="kiv-section">
        <b-card-header class="p-2">
            <h4 class="mb-0">Customer E-Sign Documents</h4>
        </b-card-header>
        <div class="card-table-simple">
            <b-table-simple responsive class="mb-0">
                <b-thead>
                    <b-tr>
                        <b-th>Documents</b-th>
                        <b-th>Status</b-th>
                        <b-th>Generated On</b-th>
                        <b-th>Signed Date</b-th>
                        <b-th></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(doc, index) in documentsUploaded" :key="index">
                        <b-td class="text-primary font-weight-500">{{ doc.doc_name }}</b-td>
                        <b-td :class="{
                            'text-success': doc.doc_sts === 'Signed',
                            'text-danger': doc.doc_sts === 'Unsigned',
                            'text-muted': doc.doc_sts === 'Not Generated'
                        }">
                            {{ doc.doc_sts }}
                        </b-td>
                        <b-td>{{ doc.generated_on || '-' }}</b-td>
                        <b-td>{{ doc.signed_date || '-' }}</b-td>
                        <b-td v-if="doc.doc_sts === 'Signed'" class="text-danger">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2l17.6-17.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3-163.8-62.5-226.3 0L125.7 160z"/></svg>
                            <span class="ml-2">Reset all</span>
                        </b-td>
                        <b-td v-else-if="doc.doc_sts === 'Unsigned'" class="text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2l17.6-17.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3-163.8-62.5-226.3 0L125.7 160z"/></svg>
                            <span class="ml-2">Re-generate Link</span>
                        </b-td>
                        <b-td v-else-if="doc.doc_sts === 'Not Generated'" class="text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="currentColor" d="M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v125.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm165.8 107.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"/></svg>
                            <span class="ml-2">Generate Link</span>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </b-card>
</template>
<script>
export default {
    data() {
        return {
            documentsUploaded: [
                {
                    doc_name: 'Application Form',
                    doc_sts: 'Signed',
                    generated_on: '8 May 2023',
                    signed_date: '8 May 2023'
                },
                {
                    doc_name: 'Letter Offer',
                    doc_sts: 'Unsigned',
                    generated_on: '9 May 2023',
                    signed_date: ''
                },
                {
                    doc_name: 'Loan Agreement',
                    doc_sts: 'Not Generated',
                    generated_on: '',
                    signed_date: ''
                }
            ]
        }
    }
}
</script>